const messages = {
    requiredField: "Este campo deve ser informado",
    optionNotExist: "Escolha uma opção existente!",
    invalidDate: "A data informada é inválida",
    createSucess: "Registro gravado com sucesso!",
    createError: "Ocorreu um erro e o registro não foi gravado!",
    updateSucess: "Registro atualizado com sucesso!",
    updateError: "Ocorreu um erro e o registro não foi atualizado!",
    deleteConfirmation: "Deseja realmente excluir o registro?",
    deleteSucess: "Registro excluido com sucesso!",
    disableSucess: "Registro desabilitado com sucesso!",
    inactiveConfirmation: "Deseja realmente inativar o registro?",
    deleteError: "Ocorreu um erro e o registro não foi excluido!",
    disableError: "Ocorreu um erro e o registro não foi desabilitado!",
    getWithFilterError: "Ocorreu um erro ao obter os registros!",
    approveErrorAll: "Ocorreu um erro ao aprovar os registros!",
    approveSuccessAll: "Registros aprovados com sucesso!",
    approveError: "Ocorreu um erro ao aprovar o registro!",
    approveSuccess: "Registro aprovado com sucesso!",
    reopenError: "Ocorreu um erro ao reabrir o registro!",
    downloadError: "Ocorreu um erro ao baixar o arquivo!",
    uploadError: "Ocorreu um erro ao realizar upload do arquivo!",
    undoConfirmation: "Deseja realmente desfazer o saldo?",
    undoSucess: "Saldo desfeito com sucesso!",
    undoError: "Ocorreu um erro e o saldo não foi desfeito!",
    reportSucess: "Requisição de relatório efetuada com sucesso",
    reportError: "Ocorreu um erro ao requisitar o relatório",
    confirmTableEditDevolucao: "Deseja realmente alterar o cadastro de devolução de impostos do cliente?",
    confirmTableEditTravaFatura: "Deseja realmente alterar o cadastro de trava de fatura do cliente?",
    confirmTableEditRegraDataVencimento: "Deseja realmente alterar a regra de vencimento do cliente?",
    faturas: {
        download: "Tem certeza que deseja baixar todas as faturas publicadas hoje?",
        error: "Ocorreu um erro e não foi possível realizar o download!",
    },
};

export default messages;
